import { render, staticRenderFns } from "./ModalAlteraSenha.vue?vue&type=template&id=42656ceb&"
import script from "./ModalAlteraSenha.vue?vue&type=script&lang=js&"
export * from "./ModalAlteraSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports